import React, { ReactNode } from 'react';
import styles from './styles.module.scss';

type DetailRowProps = {
    label: string;
    children: ReactNode;
};

/*
 * A single zebra-striped label/value row, shared by every details tab across the dashboard
 */
export function DetailRow({ label, children }: DetailRowProps) {
    return (
        <div className={styles.detailRow}>
            <div className={styles.detailLabel}>{label}</div>
            <div className={styles.detailValue}>{children}</div>
        </div>
    );
}
